import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ExitIntentPopup from "../ExitIntentPopup";
import CartDrawer from "../CartDrawer";
import StorefrontBootstrap from "../StorefrontBootstrap";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-cream-100 text-ink-900">
      {/*
        Mounted here (not just on Home) so the Meta Pixel loads for every
        storefront entry point — ad clicks and shared links routinely land
        shoppers directly on /product/:id or /shop, and ViewContent/
        AddToCart events fired before the pixel is initialized are lost.
      */}
      <StorefrontBootstrap />
      <Navbar />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <ExitIntentPopup />
    </div>
  );
}
